import React, { useCallback, useState } from 'react';

import api from '../../../services/api';
import { useToast } from '../../../hooks/toast';
import { AppError } from '../../../utils/AppError';

import { Container, Content, Header, AcessoDados, ButtonsView } from './styles';

interface ModalPARAMS {
  id?: string;
  onClose: any;
  isVisible: boolean;
  acesso: AcessoDATA;
  setAcessos: any;
  setPesqAcessos: any;
}
interface AcessoDATA {
  id: number;
  email: string;
  nome: string;
  role: string;
  status: string;
  password?: string;
}

const ModalPerfilDeleteAcesso: React.FC<ModalPARAMS> = ({
  onClose = () => {},
  isVisible,
  acesso,
  setAcessos,
  setPesqAcessos,
}) => {
  const handleOnClose = useCallback(() => {
    setVisible(false);
    setTimeout(() => {
      onClose();
    }, 300);
  }, [onClose]);

  const { addToast } = useToast();
  const [visible, setVisible] = useState(isVisible);

  // const handleDeleteAcesso = useCallback(async () => {
	async function handleDeleteAcesso() {
		try {
			const { data } = await api.delete(`portal/user/remove/${acesso.id}`);

			setAcessos(data.acessos);
			setPesqAcessos(data.acessos);

			if (data.acesso.status === 'S') {
				addToast({
					type: 'success',
					title: 'Acesso Removido',
					description: `Acesso removido com sucesso!`,
				});
			} else {
				addToast({
					type: 'success',
					title: 'Acesso Restaurado',
					description: `Acesso restaurado com sucesso!`,
				});
			}
		}
		catch (error) {
			const isAppError = error instanceof AppError;
			const msg = isAppError ? error.message : 'Não foi possível remover o acesso.';

			addToast({
				type: 'error',
				title: 'Remover Acesso!',
				description: msg,
			});
		}
		finally {
			handleOnClose();
		}
  }; // , [acesso, setAcessos, setPesqAcessos, addToast, handleOnClose]);

  return (
    <Container id="modalPerfilDeleteAcesso">
      <Content className={`${visible ? 'active' : ''}`}>
        <Header>
          {acesso.status === 'S' ? (
            <>
              <h1>Remover Acesso ao Portal.</h1>
              <h2>Deseja mesmo remover este acesso ao portal?</h2>
            </>
          ) : (
            <>
              <h1>Restaurar Acesso ao Portal.</h1>
              <h2>Deseja mesmo restaurar este acesso ao portal?</h2>
            </>
          )}
        </Header>

        <AcessoDados>
          <h1>{acesso.nome}</h1>
          <h2>{acesso.email}</h2>
          <h2>{acesso.role}</h2>
        </AcessoDados>

        <ButtonsView>
          <button className="btn-cancel" onClick={handleOnClose}>
            Cancelar
          </button>
          <button className="btn-save" onClick={handleDeleteAcesso}>
            {acesso.status === 'S' ? 'Remover' : 'Restaurar'}
          </button>
        </ButtonsView>
      </Content>
    </Container>
  );
};

export default ModalPerfilDeleteAcesso;
